import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
// const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// logs routing
const LogsHistory = Loadable(lazy(() => import('views/logs/History')));
const LogsShow = Loadable(lazy(() => import('views/logs/Show')));
const LogsCreate = Loadable(lazy(() => import('views/logs/Create')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    // {
    //   path: 'sample',
    //   element: <DashboardDefault />,
    // },
    {
      path: 'logs',
      children: [
        {
          path: 'history',
          element: <LogsHistory />
        },
        {
          path: 'history/:id',
          element: <LogsShow />
        }
      ]
    },
    {
      path: 'logs',
      children: [
        {
          path: 'create',
          element: <LogsCreate />
        }
      ]
    }
  ]
};

export default MainRoutes;
